import { breadCrumbsInitialData } from 'templates/pages/Categories/constants';
import { BreadCrumbData } from 'templates/types';
import { GetTemplatesNavigationDataArgs } from './types';

const getTemplatesNavigationData = ({
  query,
  selectedCategory,
}: GetTemplatesNavigationDataArgs): { breadCrumbsData: Array<BreadCrumbData> } => {
  const data: Array<BreadCrumbData> = selectedCategory?.parent
    ? [...breadCrumbsInitialData, selectedCategory?.parent, selectedCategory]
    : [...breadCrumbsInitialData, selectedCategory];

  if (selectedCategory?.name === breadCrumbsInitialData[0].name) {
    data.splice(1, 1);
  }

  const queryParam = query.get('q');
  if (queryParam) {
    data.push({ name: queryParam, title: queryParam } as BreadCrumbData);
  }
  return { breadCrumbsData: data.filter(item => item) };
};

export default getTemplatesNavigationData;
